import { IEvent } from '../services/api/eventApi';

export type RegistrationTarget =
  | { kind: 'external'; url: string }
  | { kind: 'internal'; path: string }
  | { kind: 'none' };

/**
 * 메인 화면 '접수신청' 버튼이 어디로 보낼지 정한다.
 *
 * 관리자가 이벤트에 링크(event_Link)를 넣었으면 그 링크가 항상 우선이다.
 * 링크가 없을 때만 이벤트 이름으로 내장 접수 페이지(성경퀴즈대회·올림픽)를 고르고,
 * '설명회'는 본 행사 접수 페이지로 보내지 않는다.
 */
export function resolveRegistrationTarget(
  event: Pick<IEvent, '_id' | 'event_Name' | 'event_Link'>
): RegistrationTarget {
  const link = event.event_Link?.trim();
  if (link) return { kind: 'external', url: link };

  const name = event.event_Name ?? '';
  const isInfoSession = name.includes('설명회');

  if (name.includes('성경퀴즈대회') && !isInfoSession) {
    return { kind: 'internal', path: `/bq-register/${event._id}` };
  }
  if (name.includes('올림픽') && !isInfoSession) {
    return { kind: 'internal', path: `/olympic-register/${event._id}` };
  }
  return { kind: 'none' };
}
